import { baseApi, client } from '../baseApi.ts';

export const mediaEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		submitFeedback: builder.mutation({
			// @ts-ignore
			queryFn: async ({ mediaId, feedbackRequest }) => {
				try {
					const response = await client.media.submitFeedback(mediaId, feedbackRequest);
					return { data: response.data };
				} catch (error) {
					throw new Error(error);
				}
			},
		}),
		deleteMedia: builder.mutation({
			// @ts-ignore
			queryFn: async (mediaId: string) => {
				try {
					const response = await client.media.delete(mediaId);
					return { data: response.data };
				} catch (error) {
					throw new Error(error);
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Media', id }],
		}),
		deleteMultipleMedia: builder.mutation({
			// @ts-ignore
			queryFn: async (mediaIds: string[]) => {
				try {
					const response = await client.media.deleteMultiple({ image_ids: mediaIds });
					return { data: response.data };
				} catch (error) {
					throw new Error(error);
				}
			},
			invalidatesTags: ['Media'],
		}),
		removeImageBackground: builder.mutation({
			// @ts-ignore
			queryFn: async ({ inputImageId }) => {
				try {
					const response = await client.media.removeBackground({ input_image_id: inputImageId });
					return { data: response.data };
				} catch (error) {
					throw new Error(error);
				}
			},
		}),
	}),
});
